import { AppBar, Tab } from "@mui/material";
import { TabLargeStyle } from "assets/jss/common-styles";
import { AppBarTabs } from "components/AppTabs";
import MuiContainer from "components/MuiExtras/MuiContainer";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import BadgeAdminList from "views/Gamification/BadgeAdminList";
import AwardEdit from "views/Gamification/Components/AwardEdit";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    currentTab: TabOptions,
}

type Props = WithTranslation;

enum TabOptions { Badge, Award }

/////////////////////////////////////////////////////////////////////////////////////

class GamificationSetup extends React.Component<Props, IState> {

    private tabs: Array<React.ReactElement> = [];

    ///
    constructor(props: Props) {
        super(props);

        let initialTab: TabOptions = null;

        this.tabs.push(<Tab key={TabOptions.Award} value={TabOptions.Award} label={this.props.t<string>("Views.Gamification.GamificationSetup.TabAward")} style={TabLargeStyle} />);
        this.tabs.push(<Tab key={TabOptions.Badge} value={TabOptions.Badge} label={this.props.t<string>("Views.Gamification.GamificationSetup.TabBadge")} style={TabLargeStyle} />);

        initialTab = TabOptions.Award;

        this.state = {
            currentTab: initialTab
        };
    }

    ///
    private handleTabSelection = (event: React.ChangeEvent<{}>, value: any) => {
        this.setState({ currentTab: value });
    };

    ///
    private renderFormMenuBar(): JSX.Element {

        return (
            <MuiContainer margin="dense">
                <AppBar position="static" color="primary"  >
                    <AppBarTabs
                        centered
                        value={this.state.currentTab}
                        onChange={this.handleTabSelection}
                    >
                        {this.tabs}
                    </AppBarTabs>
                </AppBar>
            </MuiContainer>
        );
    }

    ///
    render() {
        return (
            <>
                {this.renderFormMenuBar()}

                {
                    this.state.currentTab == TabOptions.Badge
                        ? <BadgeAdminList />
                        : <AwardEdit />
                }

            </>
        );
    }
}

export default withTranslation()(GamificationSetup);